'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./sg-dashboard-sdk.cjs.production.min.js');
} else {
  module.exports = require('./sg-dashboard-sdk.cjs.development.js');
}